import Cookies from 'js-cookie';
import { showError, useRuntimeConfig } from '#imports';

function createApiFetchClient() {
  const config = useRuntimeConfig();
  const locale = Cookies.get('i18n_redirected');
  const token = Cookies.get('auth_token');

  return $fetch.create({
    baseURL: `${config.public.apiUrl}`,
    headers: {
      'Accept-Language': locale,
      Accept: 'application/json',
      Authorization: `Bearer ${token}`,
    } as {
      'Accept-Language': string;
      Accept: string;
      Authorization: string;
    },
    onResponse({ response }) {
      fatalErrorHandler(response);
    },
  });
}

export async function apiFetch<T>(
  request: string,
  options?: Parameters<ReturnType<typeof createApiFetchClient>>[1]
) {
  const client = createApiFetchClient();
  return await client<T>(request, options);
}

export function fatalErrorHandler(response: Response) {
  if (response.status === 500) {
    showError({
      statusCode: response.status,
      statusMessage: '',
      fatal: true,
    });
  }
  if (response.status === 401) {
    Cookies.remove('auth_token');
    navigateTo('/login', { external: true });
  }
}
